import auth from '~/modules/auth/auth'

const authData = {
  computed: {
    authToken() {
      return auth.getAuthToken()
    },
    guestToken() {
      return this.$router.currentRoute.query?.token
    },
    onlyAuthenticatedUser() {
      return !this.guestToken && this.authToken
    }
  }
}

export default authData
